import React from 'react';
// Styles
import './loader.css';
const Loader = () => {
  return <div className="loader">Loading...</div>;
};

export default Loader;
